import { Stack, Typography } from '@mui/material';

interface SectionHeadingProps {
  title: string;
  barColor: string;
}

export default function SectionHeading({ title, barColor }: SectionHeadingProps) {
  return (
    <Stack direction='row' gap={1.5} alignItems='center'>
      <Stack
        sx={{
          width: 4,
          height: 24,
          borderRadius: 1,
          backgroundColor: barColor,
          flexShrink: 0,
        }}
      />
      <Typography variant='h5' sx={{ fontWeight: 600 }}>
        {title}
      </Typography>
    </Stack>
  );
}
